// extracted by mini-css-extract-plugin
export default {"storedValueEditModal":"storedValueEditModal_storedValueEditModal__rGxLH"};